// src/components/educationModal.js
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  FormControl,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import calendar from "../../assets/icon/calendarblack.png";
import { DateCp } from "../customerDetail/dateCp";
import dayjs from "dayjs";
export default function EducationModal({
  open,
  handleClose,
  onSave,
  editData,
}) {
  const [educationData, setEducationData] = useState({
    courseName: "",
    instituteName: "",
    universityName: "",
    dateOfPassing: null,
    percentage: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEducationData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (editData) {
      setEducationData({
        ...editData,
        dateOfPassing: editData.dateOfPassing
          ? dayjs(editData.dateOfPassing)
          : null,
      });
    } else {
      setEducationData({
        courseName: "",
        instituteName: "",
        universityName: "",
        dateOfPassing: null,
        percentage: "",
      });
    }
  }, [editData]);

  const handleAdd = () => {
    onSave({
      ...educationData,
      percentage: educationData.percentage
        ? parseFloat(educationData.percentage)
        : 0,
      dateOfPassing: educationData.dateOfPassing
        ? dayjs(educationData.dateOfPassing).format("YYYY-MM-DD")
        : null,
    });
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: { xs: "95%", sm: 360 },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "600",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#01008B",
        }}
      >
        Add Education
        <IconButton onClick={handleClose} sx={{}}>
          <CloseIcon sx={{ fontSize: "25px" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} md={12}>
            <TextField
              label="Course Name"
              name="courseName"
              value={educationData.courseName}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <TextField
              label="Institute Name"
              name="instituteName"
              value={educationData.instituteName}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="University Name"
              name="universityName"
              value={educationData.universityName}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Date of Passing"
                value={educationData.dateOfPassing}
                onChange={(newValue) =>
                  setEducationData((prev) => ({
                    ...prev,
                    dateOfPassing: newValue,
                  }))
                }
                slotProps={{ textField: { size: "small", fullWidth: true } }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Percentage"
              name="percentage"
              value={educationData.percentage}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          p: 2,
        }}
      >
        <Button variant="contained" onClick={handleAdd} fullWidth>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
